export default {
  defaultProps: {
    PaperProps: {
      variant: 'elevation'
    }
  }
}
